import { handleRedirectMiddleware } from '@nuxt-monorepo/ui/utils/seo';
import { checkL4EarlyRedirect } from '~/utils/seo';
import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (import.meta.client) return;

    const {
        public: { STORYBLOK_FOLDER, STORYBLOK_VERSION, STORYBLOK_TOKEN },
    } = useRuntimeConfig();

    const result = await handleRedirectMiddleware(to, from, checkL4EarlyRedirect, {
        folder: STORYBLOK_FOLDER,
        version: STORYBLOK_VERSION,
        token: STORYBLOK_TOKEN,
    });

    if (result?.type === 'redirect') {
        return navigateTo(result.target, {
            external: true,
            redirectCode: result.statusCode ?? 302,
        });
    }
});
